import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guard/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('src/app/pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'login/:access',
    loadChildren: () =>
      import('src/app/pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/pages/menu/menu.module').then((m) => m.MenuPageModule),
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
